export const REPO_SOURCE_NAME = 'tribe-neo'
